const digest = 'b5b5fd91d14ba4fe027a4ec0797c549eb15499d30d5575911b4eebc2e78de2f0';
const css = `._navBar_1mpxk_1{align-items:center;background-color:#fff;bottom:0;display:flex;justify-content:space-around;padding:0 1rem;position:fixed;width:100%;z-index:1}._navBar_1mpxk_1 ._navName_1mpxk_12{color:#53565a;text-align:center}._navItem_1mpxk_17{align-items:center;align-self:stretch;display:flex;flex:1 0 0;flex-direction:column;gap:.75rem;padding:.75rem 0 .5rem}._selectedTab_1mpxk_27{border-top:3px solid #006fcf}._selectedTab_1mpxk_27:hover{text-decoration:none}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'navBar': '_navBar_1mpxk_1', 'navName': '_navName_1mpxk_12', 'navItem': '_navItem_1mpxk_17', 'selectedTab': '_selectedTab_1mpxk_27' };
export const navBar = '_navBar_1mpxk_1';
export const navName = '_navName_1mpxk_12';
export const navItem = '_navItem_1mpxk_17';
export const selectedTab = '_selectedTab_1mpxk_27';
export { css, digest };